module.exports = __webpack_public_path__ + "img/ARRASTAR.6618096a.svg";